/** connect — EN source. */
export const connect = {
  connect_launcher_title: "Connect",
  connect_launcher_subtitle:
    "Match in person — show your QR for someone to scan, or confirm a scan to connect instantly.",
  connect_launcher_open_button: "Open Connect",

  // Shared error / action labels
  connect_error_title: "Couldn't load",
  connect_error_subtitle: "Check your connection and try again",
  connect_action_try_again: "Try again",
  connect_action_close: "Close",
  connect_action_done: "Done",
  connect_action_continue: "Continue",

  // QR screen (owner home)
  connect_qr_title: "Your QR Code",
  connect_qr_hint:
    "Have someone scan this QR code to automatically match with you",
  connect_qr_error_title: "Couldn't load your QR",

  // Scan result (scanner B)
  connect_scan_request_sent_heading: "Request sent",
  connect_scan_request_sent_to: "to {name}",
  connect_scan_pending_status: "Pending Match",
  connect_scan_already_connected_heading:
    "You're already connected with {name}",
  connect_scan_self_heading: "You can't connect with yourself",
  connect_scan_invalid_title: "Invalid link",
  connect_scan_invalid_subtitle: "This QR code isn't valid anymore",

  // Match / consent gate (owner A)
  connect_match_error_title: "Couldn't load this request",
  connect_match_heading: "Match with {name}?",
  connect_match_button: "Match",
  connect_match_matching: "Matching…",
  connect_match_decline: "Not now",
  connect_match_matched_heading: "You matched with {name}",
  connect_match_expired_heading: "This request has expired",

  // Toasts
  connect_toast_matched_with: "Matched with {name}",
  connect_toast_matched: "Matched",
  connect_toast_match_failed: "Couldn't form the match",
};
